import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { themeColors } from '../../JuvareTheme';
import { useCommonWebTranslation } from '../../hooks';
/**
 * Renders a labeled tab component with optional icon and badge.
 * Shows a tooltip for keyboard reordering when applicable.
 *
 * @param {GlobalTabLabelProps} root0 - Props for the component.
 * @param {GlobalTab[]} root0.tabs - List of all open tabs.
 * @param {string} [root0.selectedTabPath] - Path of the currently selected tab.
 * @param {GlobalTab} root0.tab - Tab to render the label for.
 * @param {boolean} [root0.showKeyboardTooltip] - Whether to show tooltip for keyboard interaction.
 * @returns {JSX.Element} A rendered tab label with optional icon, badge, and close button.
 */
export const GlobalTabLabel = ({ tabs, selectedTabPath, tab, showKeyboardTooltip }) => {
    const { t } = useCommonWebTranslation();
    return (React.createElement(Tooltip, { title: tabs.length > 1 && selectedTabPath === tab.path ? (React.createElement(React.Fragment, null,
            tab.label,
            React.createElement("br", null),
            t('globalTabsBar.useKeyboardToReorderTabsTooltip'))) : null, open: showKeyboardTooltip },
        React.createElement(Box, { sx: { display: 'flex', alignItems: 'center' } },
            tab.badge && (React.createElement(Box, { sx: { display: 'flex', color: themeColors.accent.red.bold, pr: 1 }, "data-test": 'badge', "aria-label": t('globalTabsBar.badge') },
                React.createElement(FiberManualRecordIcon, { fontSize: 'inherit' }))),
            tab.icon && (React.createElement(Box, { sx: { display: 'flex', color: themeColors.text.link, pr: 1 }, "data-test": 'icon' }, tab.icon)),
            React.createElement(Typography, { variant: 'button', sx: {
                    color: themeColors.text.link,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '185px',
                }, "data-test": 'label', title: tab.label }, tab.label))));
};
